/**
 * 鉴权 UI 状态。
 *
 * 仅放：
 *  - 当前 access token（内存中；刷新页面会丢，由 /auth/refresh + cookie 复活）
 *  - 当前用户简档（cache，方便顶部导航等组件直读，**真理来源** 仍是 /auth/me）
 *  - "认证检查是否已完成"标志，让 AuthGuard 等待初次自检结束
 *
 * 不放：
 *  - 病例 / 用户列表 等服务器数据（走 TanStack Query，[CODING_STANDARDS §4.2]）
 *  - refresh token（HttpOnly cookie 自动管理，前端不读不写）
 */
import { create } from 'zustand';
import type { AuthenticatedUser } from '@dental/shared-types';

type AuthState = {
  status: 'unknown' | 'authenticated' | 'unauthenticated';
  user: AuthenticatedUser | null;
  accessToken: string | null;
  /** UNIX 秒；前端用作"快过期"判断辅助 */
  accessTokenExpiresAt: number | null;
  setAuthenticated: (params: {
    user: AuthenticatedUser;
    accessToken: string;
    accessTokenExpiresAt: number;
  }) => void;
  setUnauthenticated: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  status: 'unknown',
  user: null,
  accessToken: null,
  accessTokenExpiresAt: null,
  setAuthenticated: ({ user, accessToken, accessTokenExpiresAt }) =>
    set({ status: 'authenticated', user, accessToken, accessTokenExpiresAt }),
  setUnauthenticated: () =>
    set({ status: 'unauthenticated', user: null, accessToken: null, accessTokenExpiresAt: null }),
}));
